module.exports = __webpack_public_path__ + "img/switch.34d5189e.png";